/* GAP configurator add-on, loaded by the Custom Liquid section in templates/page.gap-configurator.json. RAW photos:
   camera RAW files carry a JPEG made by the camera. It is found by walking every JPEG start marker in the file, the
   largest one the browser can decode is used (lossless RAW data that only looks like a JPEG fails to decode and is
   skipped), it is turned upright from the RAW's own TIFF orientation, and handed to the normal upload as a .jpg.
   Listens on window in the capture phase, so it runs before the file type check in gap-configurator-file.js. If no
   usable image is found, or it is smaller than MIN_SIDE, the customer is asked for a JPG instead. */
(function () {
  var RAW_EXT = /\.(cr2|cr3|crw|nef|nrw|arw|srf|sr2|dng|raf|orf|rw2|pef|srw|3fr|iiq|erf|kdc|mrw|x3f)$/i;
  var MIN_SIDE = 1600, MAX_BYTES = 200 * 1024 * 1024, MIN_JPEG = 20 * 1024;
  var SEL_FILE = '[data-gapcfg] [data-file]';
  function q(s) { return document.querySelector(s); }
  function say(msg, err) {
    var st = q('[data-gapcfg] [data-status]');
    if (!st) { if (err) window.alert(msg); return; }
    st.textContent = msg; st.classList.toggle('is-error', !!err); st.hidden = false;
  }
  /* end offset (exclusive) of the JPEG starting at s, or -1 if the markers don't hold together */
  function jpegEnd(b, s) {
    var n = b.length, p = s + 2, guard = 0;
    while (p < n - 1 && guard++ < 10000) {
      if (b[p] !== 0xFF) return -1;
      while (b[p] === 0xFF && p < n - 1) p++;
      var m = b[p++];
      if (m === 0xD9) return p;
      if ((m >= 0xD0 && m <= 0xD7) || m === 0x01) continue;
      if (p + 1 >= n) return -1;
      var len = (b[p] << 8) | b[p + 1];
      if (len < 2) return -1;
      p += len;
      if (m === 0xDA) {
        while (p < n - 1 && !(b[p] === 0xFF && b[p + 1] !== 0x00 && !(b[p + 1] >= 0xD0 && b[p + 1] <= 0xD7))) p++;
      }
    }
    return -1;
  }
  function candidates(b) {
    var out = [];
    for (var i = 0; i < b.length - 3; i++) {
      if (b[i] !== 0xFF || b[i + 1] !== 0xD8 || b[i + 2] !== 0xFF) continue;
      var e = jpegEnd(b, i);
      if (e > 0 && e - i >= MIN_JPEG) { out.push([i, e]); i = e - 1; }
    }
    return out.sort(function (x, y) { return (y[1] - y[0]) - (x[1] - x[0]); });
  }
  /* EXIF orientation from a TIFF-based RAW (CR2, NEF, ARW, DNG, ORF, PEF ...); 1 when unknown */
  function orientation(b) {
    var le = b[0] === 0x49 && b[1] === 0x49, be = b[0] === 0x4D && b[1] === 0x4D;
    if (!le && !be) return 1;
    var dv = new DataView(b.buffer, b.byteOffset, b.byteLength);
    try {
      var ifd = dv.getUint32(4, le), cnt = dv.getUint16(ifd, le);
      for (var k = 0; k < cnt; k++) {
        var e = ifd + 2 + k * 12;
        if (dv.getUint16(e, le) === 0x0112) return dv.getUint16(e + 8, le) || 1;
      }
    } catch (x) {}
    return 1;
  }
  function decode(blob) {
    if (window.createImageBitmap) return createImageBitmap(blob, { imageOrientation: 'none' });
    return new Promise(function (ok, fail) {
      var u = URL.createObjectURL(blob), im = new Image();
      im.onload = function () { URL.revokeObjectURL(u); ok(im); };
      im.onerror = function () { URL.revokeObjectURL(u); fail(new Error('decode')); };
      im.src = u;
    });
  }
  function firstDecodable(b, list, i) {
    if (i >= list.length) return Promise.reject(new Error('none'));
    var blob = new Blob([b.subarray(list[i][0], list[i][1])], { type: 'image/jpeg' });
    return decode(blob).then(function (img) { return { blob: blob, img: img }; }, function () { return firstDecodable(b, list, i + 1); });
  }
  function upright(found, o) {
    if (o !== 3 && o !== 6 && o !== 8) return Promise.resolve(found.blob);
    var im = found.img, w = im.width, h = im.height, c = document.createElement('canvas');
    c.width = o === 3 ? w : h; c.height = o === 3 ? h : w;
    var g = c.getContext('2d');
    if (o === 3) { g.translate(w, h); g.rotate(Math.PI); }
    else if (o === 6) { g.translate(h, 0); g.rotate(Math.PI / 2); }
    else { g.translate(0, w); g.rotate(-Math.PI / 2); }
    g.drawImage(im, 0, 0);
    return new Promise(function (ok, fail) { c.toBlob(function (x) { x ? ok(x) : fail(new Error('encode')); }, 'image/jpeg', 0.95); });
  }
  function rawToJpg(el, f) {
    var ext = (/\.([a-z0-9]+)$/i.exec(f.name) || [])[1].toUpperCase();
    var nope = '.' + ext + ': we could not get a good-quality photo out of this RAW file. Please save a JPG copy first, or WhatsApp us on 07445 250359.';
    if (f.size > MAX_BYTES) { say(nope, true); return; }
    say('Reading your RAW photo (.' + ext + ')… this can take a few seconds.');
    f.arrayBuffer().then(function (ab) {
      var b = new Uint8Array(ab), o = orientation(b);
      return firstDecodable(b, candidates(b), 0).then(function (found) {
        var long = Math.max(found.img.width, found.img.height);
        var done = function (x) { if (found.img.close) found.img.close(); return x; };
        if (long < MIN_SIDE) throw done(new Error('small'));
        return upright(found, o).then(done);
      });
    }).then(function (jpg) {
      var file = new File([jpg], f.name.replace(RAW_EXT, '') + '.jpg', { type: 'image/jpeg', lastModified: Date.now() });
      var dt = new DataTransfer(); dt.items.add(file);
      el.files = dt.files;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }).catch(function () { el.value = ''; say(nope, true); });
  }
  window.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches(SEL_FILE)) return;
    var f = el.files && el.files[0];
    if (!f || !RAW_EXT.test(f.name)) return;
    e.stopImmediatePropagation();
    rawToJpg(el, f);
  }, true);
})();
